// extracted by css-extract-rspack-plugin
export default {"loaderOverlay":"loaderOverlay-Dq0YKY"};